// docs: https://github.com/altostra/type-validations#readme
import { maybe, objectOf, enumOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isIntegrationsDirectCdiSourcesTestConnectionResult = objectOf({
  result: enumOf("success", "error"),
  message: maybe(string),
});
